'use client'

import { Cell, Divider, InputText } from '@vinted/web-ui'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { isEmailValid } from '@marketplace-web/registration/email-validation-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  renderValidation,
  useFormValidationMessage,
} from '@marketplace-web/vendor-abstractions/react-hook-form-feature'

import { Field, FormModel } from './types'
import { SIGNUP_URL } from './constants/routes'

type Props = {
  isLoginTipDisplayed: boolean
}

const UserEmailField = ({ isLoginTipDisplayed }: Props) => {
  const translate = useTranslate('help_contact_form.email')
  const {
    register,
    formState: { errors },
  } = useFormContext<FormModel>()
  const validationMessage = useFormValidationMessage(errors, 'help_contact_form')

  const [isUserEmailValid, setIsUserEmailValid] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')

  function renderFasterAnswerTip() {
    return (
      <>
        <Divider />
        <Cell title={translate('login_tip')} type="navigating" chevron url={SIGNUP_URL} />
      </>
    )
  }

  function handleChange({ target }) {
    setEmail(target.value)

    const isValid = isEmailValid(target.value)

    setIsUserEmailValid(isValid)
  }

  function validate() {
    if (!isUserEmailValid) {
      return translate('errors.invalid')
    }

    return undefined
  }

  return (
    <>
      <InputText
        {...register(Field.Email, {
          required: true,
          validate,
        })}
        styling="wide"
        onChange={handleChange}
        title={translate('title')}
        placeholder={translate('placeholder')}
        value={email}
        validation={renderValidation(
          validationMessage(Field.Email, { required: translate('errors.empty') }),
        )}
      />
      {isLoginTipDisplayed && renderFasterAnswerTip()}
    </>
  )
}

export default UserEmailField
